module.exports = __webpack_public_path__ + "static/img/analyseCover.d6df8e3e.png";